import { InternalLinksType } from '@lib/data/footer'
import MsgTrans from '../i18n/message-trans'
import { LinguiJSMessageDescriptor } from '@lib/types/common'
import { msgT } from '@lib/utils/i18n'

type InternalLinksCategoryProps = {
  title: LinguiJSMessageDescriptor
  links: InternalLinksType[]
  isTranslated?: boolean
}
const InternalLinksCategory = ({
  title,
  links,
  isTranslated = true,
}: InternalLinksCategoryProps) => {
  return (
    <div className="flex flex-col">
      <p className="text-xl font-600">
        <MsgTrans msg={title} />
      </p>
      <div className="flex flex-col mt-5 space-y-3">
        {links.map((item, i) => (
          <a
            href={item.link}
            key={i}
            className="flex space-x-2 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Codingal ${
              isTranslated ? msgT(item.label) : item.label
            } page link`}
          >
            {item.icon && <>{item.icon}</>}
            <span>
              {isTranslated ? <MsgTrans msg={item.label} /> : item.label}
            </span>
          </a>
        ))}
      </div>
    </div>
  )
}
export default InternalLinksCategory
